import MyHoldings from './my-holdings';

export default MyHoldings;
